import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { isSupabaseConfigured } from '@/config';
import { useAuth } from '@/lib/auth/AuthProvider';
import { getMyReferral, redeemReferral } from '@/lib/data/provider';

/** My invite code + how many I've invited + whether I've redeemed one. */
export function useMyReferral() {
  const { userId } = useAuth();
  return useQuery({
    queryKey: ['referral', userId ?? 'anon'],
    queryFn: getMyReferral,
    enabled: isSupabaseConfigured && Boolean(userId),
  });
}

export function useRedeemReferral() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => redeemReferral(code),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['referral'] });
      queryClient.invalidateQueries({ queryKey: ['rewards'] });
    },
  });
}
